import React, { FunctionComponent } from 'react';
import { PawPrint as PetsIcon, Table as DashboardIcon, View } from 'lucide-react';
import { ShepherdLensLogo } from '@companion-professional/components';
import { cn, useOutsideClick } from '@companion-professional/webutils';
import { useMobileMenuOpen, useSetMobileMenuOpen } from '../../state/layout';
import { SideNavLink } from './SideNavLink';
import { Permissions } from '@companion-professional/dctypes';

// SideNav is the side navigation section of the application. It is the left-most section of the application and
// contains links to various pages of the application. When the screen size is reduced, it is hidden and can be opened
// by clicking the hamburger icon in the header.
export const SideNav: FunctionComponent = () => {
  const mobileMenuOpen = useMobileMenuOpen();
  const setMobileMenuOpen = useSetMobileMenuOpen();

  // This is a custom hook that will close the mobile menu when the user clicks outside of it.
  const sideNavRef = React.useRef<HTMLDivElement>(null);
  useOutsideClick(sideNavRef, () => setMobileMenuOpen(false));

  return (
    <aside
      className={cn([
        'absolute',
        'inset-y-0',
        'left-0',
        'w-64',
        'transform',
        'space-y-4',
        'bg-nav',
        'px-3',
        'text-on-nav',
        'transition',
        'duration-200',
        'ease-in-out',
        'xl:relative',
        'z-40',
        'overflow-hidden',
        {
          'translate-x-0': mobileMenuOpen,
          '-translate-x-full': !mobileMenuOpen,
          'xl:translate-x-0': !mobileMenuOpen
        }
      ])}
      ref={sideNavRef}
    >
      <div
        className="mb-8 mt-5 px-2"
        onClick={() => {
          setMobileMenuOpen(false);
        }}
      >
        <ShepherdLensLogo inverted />
      </div>
      <nav>
        <SideNavLink to="/">
          <DashboardIcon />
          <span>Dashboard</span>
        </SideNavLink>
        <SideNavLink to="/pets">
          <PetsIcon />
          <span>Pets</span>
        </SideNavLink>
        <SideNavLink to="/reviews" restrictToPermissions={[Permissions.checkup_review]}>
          <View />
          <span>Reviews</span>
        </SideNavLink>
      </nav>
    </aside>
  );
};
